import { memo, useEffect } from 'react';
import { Cart } from '@/modules/cart';
import { ErrorType } from '@/modules/models';
import { SaywhattChat, SaywhattChatProps } from '@/modules/saywhatt-chat';
import { errorAtom, useSetValue } from '@/store';
import { SessionSyncHandler } from '../session-sync-handler';

type LayoutProps = SaywhattChatProps;

export const Layout = memo<LayoutProps>(({ onSendMessage }) => {
  const setError = useSetValue(errorAtom);

  useEffect(() => {
    const onOffline = () => {
      setError(ErrorType.NoConnection);
    };

    const onOnline = () => {
      setError(null);
    };

    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, [setError]);

  return (
    <>
      <Cart />
      <SessionSyncHandler />
      <SaywhattChat onSendMessage={onSendMessage} />
    </>
  );
});

Layout.displayName = 'Layout';
